import { round } from "lodash";
import orderTranslationsHelper from "../../../../../../languages/order-translations.helper";
import OrderDetailsManageDriverAssignmentSimulationTableColumn from "./types/order-details-manage-driver-assignment-simulation-table-column";

const getColumns =
  (): OrderDetailsManageDriverAssignmentSimulationTableColumn[] => {
    const translations =
      orderTranslationsHelper.getDetailsTranslations().manageDriverAssignment
        .extended.simualtor.table;

    const tableColumns: OrderDetailsManageDriverAssignmentSimulationTableColumn[] =
      [
        {
          accessor: "driver",
          header: translations.driverHeader,
          title: translations.driverTitle,
          colSpan: 3,
        },
        {
          accessor: "model",
          header: translations.modelHeader,
          title: translations.modelTitle,
          colSpan: 2,
        },
        {
          accessor: "rate",
          header: translations.rateHeader,
          title: translations.rateTitle,
          colSpan: 2,
        },
        {
          accessor: "bonus",
          header: translations.bonusHeader,
          title: translations.bonusTitle,
          colSpan: 4,
        },
        {
          accessor: "distance",
          header: translations.distanceHeader,
          title: translations.distanceTitle,
          colSpan: 2,
        },
        {
          accessor: "cost",
          header: translations.costHeader,
          title: translations.costTitle,
          colSpan: 2,
        },
      ];

    return tableColumns;
  };

const getDistanceLabel = (distance: number): string => {
  return `${round(distance)} KM`;
};

const getCostLabel = (
  cost: number,
  bonus: number | null,
  distance: number,
): string => {
  return `${round(cost + (bonus ?? 0) * distance)} zł`;
};

const getNoValueLabel = (): string => {
  return "---";
};

const orderDetailsManageDriverAssignmentSimulationTableHelper = {
  getColumns,
  getDistanceLabel,
  getCostLabel,
  getNoValueLabel,
};

export default orderDetailsManageDriverAssignmentSimulationTableHelper;
